export default function About() {
  return (
    <section id="about" className="py-20 bg-zinc-950">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">ABOUT KING SQUARE CLUB</h2>
            <div className="w-24 h-1 bg-amber-500 mb-8"></div>
            <p className="text-white/80 text-base leading-relaxed mb-6">
              King Square Club stands as Benin City's most prestigious luxury nightclub, where sophistication meets entertainment in perfect harmony. We've redefined the nightlife experience, creating an exclusive sanctuary for those who appreciate the finer things in life.
            </p>
            <p className="text-white/80 text-base leading-relaxed mb-6">
              Our state-of-the-art venue features world-class sound systems, stunning visual displays, and an ambiance that exudes elegance and luxury. From our VIP lounges to our main floor, every corner of King Square Club is designed to provide an unforgettable experience.
            </p>
            <p className="text-white/80 text-base leading-relaxed mb-8">
              We host the city's most exclusive events, featuring renowned DJs, live performances, and themed parties that attract the elite. Whether you're celebrating a special occasion or simply seeking an extraordinary night out, King Square Club delivers excellence in every detail.
            </p>
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-black/50 p-6 rounded-lg border border-amber-500/20">
                <i className="ri-vip-crown-line text-amber-500 text-4xl mb-3"></i>
                <h3 className="text-white font-bold text-lg mb-2">VIP Experience</h3>
                <p className="text-white/70 text-sm">Exclusive tables and bottle service</p>
              </div>
              <div className="bg-black/50 p-6 rounded-lg border border-amber-500/20">
                <i className="ri-music-2-line text-amber-500 text-4xl mb-3"></i>
                <h3 className="text-white font-bold text-lg mb-2">World-Class DJs</h3>
                <p className="text-white/70 text-sm">Top entertainment every night</p>
              </div>
              <div className="bg-black/50 p-6 rounded-lg border border-amber-500/20">
                <i className="ri-goblet-line text-amber-500 text-4xl mb-3"></i>
                <h3 className="text-white font-bold text-lg mb-2">Premium Drinks</h3>
                <p className="text-white/70 text-sm">Finest selection of beverages</p>
              </div>
              <div className="bg-black/50 p-6 rounded-lg border border-amber-500/20">
                <i className="ri-shield-star-line text-amber-500 text-4xl mb-3"></i>
                <h3 className="text-white font-bold text-lg mb-2">Elite Security</h3>
                <p className="text-white/70 text-sm">Your safety is our priority</p>
              </div>
            </div>
          </div>
          <div className="relative">
            <div className="relative h-full min-h-[600px] rounded-lg overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/70819daffaf3a0853b9debeadab375ec.jpg"
                alt="King Square Club VIP Area"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}